import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';

function AskModal({ open, onClose, onSuccess }) {
  const { t } = useTranslation(['common', 'booking']);

  return (
    <Dialog
      disableBackdropClick
      open={open}
      onClose={onClose}
      aria-labelledby="cancel-participation-dialog-title"
    >
      <DialogTitle id="cancel-participation-dialog-title">
        {t('booking:cancel-participation-title')}
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText>
          {t('booking:cancel-participation-message')}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onSuccess} color="primary">
          {t('common:yes')}
        </Button>
        <Button onClick={onClose} color="primary">
          {t('common:no')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AskModal;
